import React from "react";
import CardClasses from "./Cards.module.css";
import Icon1 from "Assets/Homepage/Cards/card1.png";
import Icon2 from "Assets/Homepage/Cards/card2.svg";
import Icon3 from "Assets/Homepage/Cards/card3.png";
import { useNavigate } from "react-router";
const Card = [
    {
        icon: Icon1,
        Content:
            "Tax return preparation is a complex process that calls for sophisticated assistance and technical knowledge. As tax professionals,we are fully versed in tax law and are prepared to put our experience to work for you.",
        heading: "Individual Taxes",
        navigate: "/Preparation-of-federal-and-state-tax-returns",
    },
    {
        icon: Icon2,
        Content:
            "As a business owner, you must be aware of all tax pitfalls. Our team of business planning department will work according to the tax filing requirements and update you the tax information time by time as per your convenience over call.",
        heading: "Business & Tax Advisory Services",
        navigate: "/Business-tax-returns",
    },
    {
        icon: Icon3,
        Content:
            "Delivering premium quality and comprehensive audit assurance services is one of our highest priorities.",
        heading: "Audit & Assurance",
        navigate: "/irs-audit-representation",
    },
    {
        icon: Icon3,
        Content:
            "Using the standard tax planning system, our team of professionals will guide you on how to pay less taxes and receive optimal returns",
        heading: "Year-End Tax Planning",
        navigate: "/Advance-tax-planning",
    },
];

function Cards() {
    const navigate = useNavigate();
    return (
        <div className={CardClasses["Container"]}>
            <h3> Our Services</h3>
            <div className={CardClasses["Cards-wrapper"]}>
                {Card.map((item) => (
                    <div
                        className={CardClasses["card"]}
                        onClick={() => navigate(item.navigate)}>
                        {/*   <div className={CardClasses["icon-wrapper"]}>
                            <img src={item.icon} />
                        </div> */}
                        <h3>{item.heading}</h3>
                        <p>{item?.Content}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Cards;
